module.exports = "<label\n  *ngIf=\"label\"\n  [for]=\"id\"\n  [ngClass]=\"inputStyle.label\"\n  class=\"control-label text-left\"\n  [translate]=\"label\"\n  [attr.title]=\"tooltip | translate\"\n></label>\n<div [ngClass]=\"inputStyle.control\">\n  <input\n    [type]=\"type\"\n    class=\"form-control\"\n    [id]=\"id\"\n    [name]=\"id\"\n    [(ngModel)]=\"value\"\n    (blur)=\"onTouch()\"\n    lang=\"en-US\"\n    [disabled]=\"disabled\"\n  />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/input/cbm-input-text/cbm-input-text.component.html
// module id = ./src/app/shared/input/cbm-input-text/cbm-input-text.component.html
// module chunks = main